import { styled } from '@smooth-ui/core-sc';

const BgWhite = styled.section`
  align-items: center;
  background-color: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0;
  width: 100%;
`;

export default BgWhite;
